export default {
  api_url: '/api'
};
